<template>

  <section class="p-0">
    <div class="auth-page error-main">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="text-center">
              <h2 class="error-font">4<span>0</span>4</h2>
              <h2 class="f-bold">Oops! Error 404 not found.</h2>
              <div class="col-lg-8 m-auto col-12">
                <h4>
                  The page you were looking for doesn't exist. We think the page
                  may have moved.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
    </div>
  </section>

</template>
<script>
export default {
  name: "Pagenotfound",
  mounted: function () {
    document.body.classList.remove("inner-page");
  },
};
</script>
